import { useEffect, useState, useContext } from 'react';
import api from '../api';
import './home.css';
import { UserContext } from '../context/UserContext';

export default function MyServices() {
  const { user } = useContext(UserContext);
  const [items, setItems] = useState([]);
  useEffect(() => {
    (async () => {
      const res = await api.get('/subscriptions/me').then(r => r.data.items || []);
      setItems(res);
    })();
  }, []);
  return (
    <div className="home-page">
      <section className={user ? 'hero-offset-if-sidebar' : ''} style={{ width:'100vw', margin:0, padding:0 }}>
        <h2 className="hero-title" style={{ textAlign: 'center', margin:'0 0 8px' }}>Meine Dienstleistungen</h2>
        <p className="hero-desc" style={{ margin:'0 auto 24px', textAlign:'center', maxWidth:760 }}>Übersicht deiner gebuchten Leistungen und Buchungsdaten.</p>
        <div style={{ display:'flex', justifyContent:'center', margin:'6px 0 12px' }}>
          <a className="hero-btn-primary" href="/angebot-anfordern" style={{ textDecoration:'none' }}>Individuelles Angebot anfordern</a>
        </div>
      </section>
      <section style={{ width:'100%', maxWidth:900, margin:'0 auto', padding:'0 16px 40px 16px', color:'#fff' }}>
        <ul>
          {items.map(r => (
            <li key={r.id} style={{ background:'rgba(255,255,255,0.03)', border:'1px solid rgba(255,255,255,0.08)', borderRadius:10, padding:10, marginBottom:10 }}>
              <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', gap:10, flexWrap:'wrap' }}>
                <div>
                  <b>{r.Service?.name || '—'}</b>
                  {r.Package && <span style={{ fontSize:12, color:'#bbb' }}> · aus Paket: {r.Package.name}</span>}
                  <div style={{ fontSize:12, color:'#bbb' }}>Gebucht am {new Date(r.bookedAt).toLocaleString()}</div>
                </div>
              </div>
            </li>
          ))}
          {items.length === 0 && <li style={{ color:'#aaa' }}>Keine Buchungen vorhanden.</li>}
        </ul>
        {/* Bottom CTA to encourage new requests */}
        <div style={{ display:'flex', justifyContent:'center', marginTop: 12 }}>
          <a className="hero-btn-primary" href="/angebot-anfordern" style={{ textDecoration:'none' }}>Weitere Dienstleistung anfragen</a>
        </div>
      </section>
    </div>
  );
}
